import { TypedAnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { ReviewImpressionTrackingInfo } from "@omni/types/components/tracking/tracking-info/impression/reviewImpression.trackingInfo";

export const getBazaarvoiceImpression = (
    data: TypedAnalyticsEvent<ReviewImpressionTrackingInfo>
) => {
    const eventData = data.payload.eventData;

    const impressionData: BV.ImpressionData = {
        bvProduct: "RatingsAndReviews",
        contentId: eventData.contentId,
        productId: eventData.productId,
        brand: eventData.brand,
        categoryId: eventData.categoryId,
        contentType: "review"
    };

    return impressionData;
};
